import _toConsumableArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { convertBlobToFile, generateRandomNumber } from "../../../helpers/Functions";
import Cropper from "../../../components/image/Cropper.vue";
import ImagePreview from "../../../components/image/ImagePreview";
import providerApiService from "../../../services/api/ProviderApiService";
import heic2any from "heic2any";
export default {
  name: "Attachments.vue",
  components: {
    Cropper: Cropper,
    ImagePreview: ImagePreview
  },
  data: function data() {
    return {
      attachments: this.initialAttachments(),
      selectedIndex: 0,
      imageBase64: "",
      fileType: "",
      cropPopupVisible: false,
      selectedImageForPreview: "",
      maxAttachments: 10
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  props: {
    data: {
      type: Array,
      required: false
    },
    aspectRatio: {
      type: Number,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    },
    accept: {
      type: String,
      required: false,
      default: "file/*"
    },
    urlForDelete: {
      type: String,
      required: false
    }
  },
  methods: {
    initialAttachments: function initialAttachments() {
      if (Array.isArray(this.data) && this.data.length > 0) {
        return this.data.map(function (element) {
          return {
            id: element.id,
            url: element.url,
            isFromServer: true
          };
        });
      }

      return [{
        id: generateRandomNumber()
      }];
    },
    getData: function getData() {
      var list = this.attachments.filter(function (item) {
        return item.file;
      }).map(function (element) {
        return element.file;
      });
      return list;
    },
    cropImage: function cropImage(blob) {
      this.cropPopupVisible = false;
      this.imageSource = "";
      var file = convertBlobToFile(blob);
      this.modifyAttachment(file);
    },
    handleSelectFile: function handleSelectFile(event, index) {
      var _this = this;

      var file = event.target.files[0];
      this.selectedIndex = index;
      var lastDot = file.name.lastIndexOf(".");
      var ext = file.name.substring(lastDot + 1);
      this.cropPopupVisible = true;

      if (ext.toLowerCase().includes("heic")) {
        heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.5 // cuts the quality and size by half

        }).then(this.selectFile).catch(function () {
          _this.$vs.notify({
            text: "خطا در بارگذاری فایل. لطفا مجدد تلاش کنید.",
            color: "danger",
            position: "bottom-center"
          });
        });
      } else {
        this.selectFile(file);
      }
    },
    selectFile: function selectFile(file) {
      this.fileType = file.type;

      if (this.fileType.includes("image")) {
        this.imageBase64 = URL.createObjectURL(file); // Base64
      } else {
        this.modifyAttachment(file);
      }
    },
    modifyAttachment: function modifyAttachment(file) {
      var _this2 = this;

      if (file) {
        var newAttachments = _toConsumableArray(this.attachments); // Clone all the attachments

        /**
         * Find attachment index for modifying
         */


        var attachmentIndex = newAttachments.findIndex(function (_el, i) {
          return i === _this2.selectedIndex;
        });
        /**
         * Modify the file of the attachment if it exists
         */

        if (attachmentIndex >= 0) {
          newAttachments[attachmentIndex].file = file;

          if (this.fileType.includes("image")) {
            newAttachments[attachmentIndex].url = URL.createObjectURL(file);
          }
        }

        this.attachments = newAttachments;
      }
    },
    addAttachment: function addAttachment() {
      this.attachments.push({
        id: generateRandomNumber()
      });
    },
    deleteAttachment: function deleteAttachment(attachment) {
      var _this3 = this;

      if (!attachment.file && attachment.url) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "\u062D\u0630\u0641 \u0639\u06A9\u0633",
          text: "\u0627\u0632 \u062D\u0630\u0641 \u0639\u06A9\u0633 \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u062F\u0627\u0631\u06CC\u062F\u061F",
          acceptText: "بلی",
          cancelText: "خیر",
          accept: function accept() {
            _this3.requestToDeleteAttachment(attachment);
          }
        });
      } else {
        this.deleteAttachmentFromClient(attachment);
      }
    },
    requestToDeleteAttachment: function requestToDeleteAttachment(attachment) {
      var _this4 = this;

      this.$vs.loading();
      providerApiService.deleteAttachment(this.urlForDelete, this.currentProvider.id, attachment.id).then(function () {
        _this4.deleteAttachmentFromClient(attachment);

        _this4.$vs.notify({
          text: "عملیات با موفقیت انجام شد.",
          color: "success",
          position: "bottom-center"
        });
      }).catch(function () {
        return _this4.$vs.notify({
          text: "عملیات با خطا مواجه شد.",
          color: "danger",
          position: "bottom-center"
        });
      }).finally(function () {
        return _this4.$vs.loading.close();
      });
    },
    deleteAttachmentFromClient: function deleteAttachmentFromClient(attachment) {
      var newAttachments = this.attachments.filter(function (element) {
        return element.id !== attachment.id;
      });
      this.attachments = newAttachments;
    },
    toggleImagePreview: function toggleImagePreview(url) {
      this.$refs.imagePreviewRef.togglePreviewVisibility();
      this.selectedImageForPreview = url;
    },
    handleClickFile: function handleClickFile(event, attachment) {
      if (attachment.isFromServer) {
        event.preventDefault();
        this.$vs.notify({
          text: "برای ویرایش عکس ابتدا آن را حذف کنید. سپس عکس مورد نظر خود را انتخاب کنید.",
          color: "warning",
          position: "bottom-center"
        });
      }
    }
  }
};